import { Link } from "react-router-dom";
import type { LucideIcon } from "lucide-react";
import { DASH } from "../../lib/format";

interface Props {
  to: string;
  icon: LucideIcon;
  label: string;
  /**
   * `undefined` : cette carte n'a pas de compteur, ou il est encore en lecture —
   * aucun nombre n'est rendu. `null` : compteur INDISPONIBLE → « — ». Un nombre
   * s'affiche tel quel, zéro compris : un vrai zéro n'est pas une panne.
   */
  count?: number | null;
  testId?: string;
  accent?: "terracotta" | "slate";
}

export function FeatureCard({ to, icon: Icon, label, count, testId, accent = "terracotta" }: Props) {
  const accentClass = accent === "terracotta" ? "text-terracotta" : "text-slate";
  return (
    <Link
      to={to}
      className="group bg-card border border-border rounded-xl2 p-5 shadow-sm hover:border-terracotta hover:shadow-md transition-all flex flex-col gap-3"
    >
      <div className="flex items-center justify-between">
        <div className={`p-2 rounded-lg bg-cream ${accentClass}`}>
          <Icon size={24} />
        </div>
        {count !== undefined && (
          <span
            data-testid={testId}
            title={count === null ? "Compteur indisponible" : undefined}
            className="text-3xl font-display font-bold text-ink"
          >
            {count === null ? DASH : count}
          </span>
        )}
      </div>
      <h3 className="font-semibold text-ink text-base">{label}</h3>
    </Link>
  );
}
